import { useRef } from 'react'

import * as Constants from '../../../constants/constants'

import useAuthenStore from '../../../stores/authen/authenStore'
import useAppFolderAndTabStore, * as AppFolderAndTabStore from '../../../stores/appFolderAndTab/appFolderAndTabStore'
import useAppFolderAndTabAction from '../../../stores/appFolderAndTab/appFolderAndTabAction'
import useManageProjectStore from '../../../stores/manageProject/useManageProjectStore'
import useManageProjectAction from '../../../stores/manageProject/useManageProjectAction'

import useCheckPermission from '../../../utilities/checkPermission'
import useWebService from '../../../services/web/useWebService'
import * as RESWebServiceTypes from '../../../services/web/types/responseWebServiceTypes'
import _ from 'lodash'
import constProjectStatus from '../../../constants/projectStatus'
import constConsiderType from '../../../constants/considerType'

export type OptType = {
    label?: string
    value?: string
}

export type CommitteeType = {
    director: OptType
    role: OptType
}
type loadTabType = {
    tabList: AppFolderAndTabStore.appFolderAndTabStoreType['tabRenderList'] | null
    selectTab: AppFolderAndTabStore.appFolderAndTabStoreType['tabSelected'] | null
    tabIndexSelected: AppFolderAndTabStore.appFolderAndTabStoreType['tabIndexSelected']
}

export default function useFolderAndTab() {
    const authenStore = useAuthenStore()
    const manageProjectStore = useManageProjectStore()
    const manageProjectAction = useManageProjectAction()
    const appFolderAndTabStore = useAppFolderAndTabStore()
    const appFolderAndTabAction = useAppFolderAndTabAction()

    const callWebService = useWebService()

    const checkPermission = useCheckPermission()

    const getProjectFolderByID = async (projectID: number) => {
        const { result } = await callWebService.getProjectFolder(projectID)

        if (result && result.folders && result.folders.length > 0) {
            const projectFolder = result.folders.map((itm: any, index: number) => {
                return {
                    ...itm,
                    id: itm.submittedID,
                    isLastProcess: index === 0 ? true : false,
                }
            })

            return projectFolder
        }

        return []
    }

    const getCommentDirector = (projectInfo: RESWebServiceTypes.GetProjectResultType | null) => {
        //#refactor projectdata
        const committeeInfo = projectInfo?.committeeInfo.map((item: any) => {
            return {
                director:
                    item.fullUsername_th && item.userID
                        ? { label: item.fullUsername_th, value: item.userID.toString() }
                        : {},
                role:
                    item.projectRoleInfo?.nameTH && item.projectRoleInfo?.value
                        ? { label: item.projectRoleInfo.nameTH, value: item.projectRoleInfo.value.toString() }
                        : {},
            }
        })
        //หาว่าคนที่login เข้ามามีหน้าที่อะไรในส่วนของบันทึกข้อคิดเห็นของกรรมการ
        const roleDirector = committeeInfo?.find(
            (element: any) => element.director.value === authenStore.profile?.userId?.toString(),
        )
        // ถ้ากรรมการที่ เข้ามามีหน้าที่เป็นกรรมการลงความเห็นในโปรเจคนี้ให้ set state เป็น true\
        let isCommiteeHavePermission = false
        if (roleDirector || checkPermission.isUserChairman()) {
            // setPresidentMustSave(true)
            isCommiteeHavePermission = true
        } else {
            // setPresidentMustSave(false)
            isCommiteeHavePermission = false
        }

        return {
            isCommiteeHavePermission,
        }
    }

    const projectFetchSeqRef = useRef(0)
    const projectFetchInflightRef = useRef<{
        key: string
        promise: Promise<RESWebServiceTypes.GetProjectResultType>
    } | null>(null)

    const getProjectByID = async (projectID?: number, submittedID?: number) => {
        if (!projectID || !submittedID) return

        const key = `${projectID}-${submittedID}`
        if (projectFetchInflightRef.current?.key === key) {
            return projectFetchInflightRef.current.promise
        }

        const seq = ++projectFetchSeqRef.current
        const promise = (async () => {
            try {
                const { result } = await callWebService.getProjectByID(Number(projectID), Number(submittedID))
                //เขียนลง store เฉพาะตอนที่ยังเป็น request ล่าสุด
                if (seq === projectFetchSeqRef.current) {
                    await manageProjectAction.setProjectData(result)
                }
                return result
            } finally {
                if (projectFetchInflightRef.current?.key === key) {
                    projectFetchInflightRef.current = null
                }
            }
        })()

        projectFetchInflightRef.current = { key, promise }
        return promise
    }

    const chkExistCustomFolder = (appFolderAndTab: typeof appFolderAndTabStore) => {
        const customFolderOnly = _.omit(Constants.customFolder, ['docAdditional', 'projectFilesUpload']) //docAdditional is folderAction
        const lstCustomFolderID: Array<number> = Object.keys(customFolderOnly).map((key) => {
            const lstCustomFolder = customFolderOnly as any
            return Number(lstCustomFolder[key].id)
        })

        const haveFolderCustom: boolean = lstCustomFolderID.indexOf(appFolderAndTab.folderList?.[0]?.id ?? NaN) !== -1

        const filterCustomFolder = appFolderAndTab.folderList?.filter(
            (itm) => lstCustomFolderID.indexOf(itm?.id ?? NaN) !== -1,
        )
        return {
            haveFolderCustom: haveFolderCustom,
            lstCustomFolder: filterCustomFolder,
        }
    }
    const isCustomFolder = (selectedFolderID: number) => {
        const lstCustomFolderID: Array<number> = Object.keys(Constants.customFolder).map((key) => {
            const lstCustomFolder = Constants.customFolder as any
            return Number(lstCustomFolder[key].id)
        })
        const isCustomFolder: boolean = lstCustomFolderID.indexOf(selectedFolderID ?? NaN) !== -1
        return isCustomFolder
    }
    const isActionFolder = (id: number) => {
        let valid: boolean = false
        if (id === Constants.customFolder.docAdditional.id) {
            return true
        }

        return valid
    }
    const loadCustomFolder = (appFolderAndTab: typeof appFolderAndTabStore) => {
        let lstCustomFolder: Array<AppFolderAndTabStore.FolderType> = []
        const chkCustomFolderInfo = chkExistCustomFolder(appFolderAndTab)
        if (chkCustomFolderInfo.haveFolderCustom) {
            lstCustomFolder = chkCustomFolderInfo.lstCustomFolder
        }
        return lstCustomFolder
    }
    const loadActionFolder = (
        projectInfo: RESWebServiceTypes.GetProjectResultType | null,
        appFolderAndTab: typeof appFolderAndTabStore,
    ) => {
        const isProjectStatusComplete: boolean = projectInfo?.projectStatusInfo?.value === constProjectStatus.completed

        let actionFolderList: Array<AppFolderAndTabStore.FolderType> = []
        const chkCustomFolder = chkExistCustomFolder(appFolderAndTab)
        if (isProjectStatusComplete && !chkCustomFolder.haveFolderCustom) {
            if (checkPermission.isUserAdmin() || checkPermission.isUserResearcher()) {
                //Folder Action ยื่นเอกสารเพิ่มพิจารณา
                actionFolderList = [...actionFolderList, Constants.customFolder.docAdditional]
            }
        }

        return actionFolderList
    }

    function loadUploadFolder() {
        const hasProjectInfo = !!manageProjectStore.projectData

        const isUserResearcher = checkPermission.isUserResearcher()
        const isUserCommittee = checkPermission.isUserCommittee()

        return hasProjectInfo && !isUserResearcher && !isUserCommittee
            ? [Constants.customFolder.projectFilesUpload]
            : []
    }

    const loadFolder = (
        folder: any,
        projectInfo: RESWebServiceTypes.GetProjectResultType | null,
        appFolderAndTab: typeof appFolderAndTabStore,
        ignoreCustomFolder: boolean = false,
    ) => {
        let selectedFolder = appFolderAndTab.folderSelected?.id ? appFolderAndTab.folderSelected : null

        if (selectedFolder === null) {
            const linkFolder = folder?.filter((itm: any) => {
                return itm?.submittedID === projectInfo?.submittedID
            })

            if (linkFolder?.length > 0) {
                selectedFolder = linkFolder[0]
            } else {
                selectedFolder = folder[0]
            }
        }

        if (ignoreCustomFolder) {
            selectedFolder = folder[0]
        }

        const actionFolder = loadActionFolder(projectInfo, appFolderAndTab)
        const customFolder = ignoreCustomFolder ? [] : loadCustomFolder(appFolderAndTab)
        const uploadFolder = loadUploadFolder()

        const mergeFolder = [...customFolder, ...folder, ...actionFolder, ...uploadFolder]

        const highlightFolder = mergeFolder.map((itm: any) => ({
            ...itm,
            isLastProcess: itm.id === selectedFolder?.id,
        }))

        return {
            lstFolder: highlightFolder,
            selectFolder: selectedFolder as AppFolderAndTabStore.FolderType,
        }
    }

    const loadCustomTab = (selectedFolder: AppFolderAndTabStore.FolderType) => {
        let returnVal: loadTabType = {
            tabList: [],
            selectTab: null,
            tabIndexSelected: 0,
        }

        returnVal = {
            tabList: [Constants.menuTab.tab21],
            selectTab: Constants.menuTab.tab21,
            tabIndexSelected: 0,
        }

        return returnVal
    }

    const loadTab = (
        projectInfo: RESWebServiceTypes.GetProjectResultType | null,
        selectedFolder: AppFolderAndTabStore.FolderType,
        ignoreCustomFolder: boolean = false,
    ) => {
        let returnVal: loadTabType = {
            tabList: [],
            selectTab: null,
            tabIndexSelected: 0,
        }

        if (!ignoreCustomFolder && isCustomFolder(selectedFolder.id as number)) {
            returnVal = loadCustomTab(selectedFolder)
        } else {
            let isNothaveCommitee: boolean
            if (
                projectInfo?.considerInfo &&
                projectInfo?.considerInfo.value === constConsiderType.exempt &&
                projectInfo?.committeeInfo.length === 0
            ) {
                isNothaveCommitee = true
            } else {
                isNothaveCommitee = false
            }
            // //กรณีที่เซตกรรมการ และกรรมการมีหน้าที่ ผู้ทบทวนหลัก + layperson เท่านั้น
            const { isCommiteeHavePermission } = getCommentDirector(projectInfo)
            const isDisapprove = false
            const hideTabCommitteeComment = isNothaveCommitee
            const { tabRenderList } = checkPermission.getTabRenderList(
                projectInfo?.submittedStatusInfo?.value,
                selectedFolder,
                hideTabCommitteeComment,
                isDisapprove,
                isCommiteeHavePermission,
                projectInfo as RESWebServiceTypes.GetProjectResultType,
            )

            let currentTabIndex = tabRenderList.length - 1

            returnVal = {
                tabList: tabRenderList,
                selectTab: tabRenderList[currentTabIndex],
                tabIndexSelected: currentTabIndex,
            }
        }

        return returnVal
    }

    const createProjectLoadTabAndFolder = () => {
        const selectedFolder = Constants.customFolder.createProject
        const { tabRenderList } = checkPermission.getTabRenderList(null, selectedFolder)
        const { folderRenderList } = checkPermission.getFolderRenderList(null)
        const folderList: Array<AppFolderAndTabStore.FolderType> = folderRenderList

        appFolderAndTabAction.setState({
            folderList: folderList,
            folderSelected: selectedFolder,
            tabRenderList: tabRenderList,
            tabSelected: tabRenderList[0],
            tabIndexSelected: 0,
        })
    }

    const getFolderAndProject = async (projectID: number, submittedID: number | null, isLoadProjectData: boolean) => {
        let returnVal: {
            projectInfo: RESWebServiceTypes.GetProjectResultType | null
            folderInfo: any
        } = {
            projectInfo: null,
            folderInfo: [],
        }

        if (projectID) {
            let lstService = [getProjectFolderByID(projectID)]
            if (isLoadProjectData) {
                if (submittedID) {
                    lstService = [...lstService, getProjectByID(projectID, submittedID)]
                    const response = await Promise.all(lstService)
                    let prjFolder: Array<any> = []
                    let projectInfo: RESWebServiceTypes.GetProjectResultType | undefined
                    prjFolder = response?.[0] ?? []
                    if (response?.[1]) {
                        projectInfo = response?.[1]
                    }

                    returnVal = {
                        projectInfo: projectInfo ?? null,
                        folderInfo: prjFolder,
                    }
                } else {
                    const loadSequence = new Promise<any>(async (resolve) => {
                        const prjFolder = await getProjectFolderByID(projectID)
                        let projectInfo: RESWebServiceTypes.GetProjectResultType | undefined
                        if (prjFolder.length > 0) {
                            const latestSubmittedID = prjFolder?.[0]?.submittedID
                            if (latestSubmittedID) {
                                projectInfo = await getProjectByID(projectID, latestSubmittedID)
                            }
                        }

                        resolve({
                            projectInfo: projectInfo ?? null,
                            folderInfo: prjFolder,
                        })
                    })

                    returnVal = await loadSequence
                }
            } else {
                const prjFolder = await getProjectFolderByID(projectID)
                returnVal = { projectInfo: null, folderInfo: prjFolder }
            }
        }
        return returnVal
    }

    const loadTabAndFolder = async (
        projectData: RESWebServiceTypes.GetProjectResultType | null,
        appFolderAndTab: typeof appFolderAndTabStore,
        isReloadProjectData: boolean = true,
        ignoreCustomFolder: boolean = false,
    ) => {
        const currentProjectID = projectData?.projectID
        let currentSubmittedID = projectData?.submittedID ?? null

        if (currentProjectID) {
            let newProjectInfo: RESWebServiceTypes.GetProjectResultType | null = projectData ?? null
            let projectFolder = []

            if (ignoreCustomFolder) {
                currentSubmittedID = null //เป็น null จะได้ข้อมูลของ Folder ล่าสุด
            }
            const infoFolderAndProject = await getFolderAndProject(
                currentProjectID,
                currentSubmittedID ?? null,
                isReloadProjectData,
            )
            if (isReloadProjectData) {
                newProjectInfo = infoFolderAndProject.projectInfo
            }
            projectFolder = infoFolderAndProject.folderInfo
            if (newProjectInfo && projectFolder.length > 0) {
                const folderInfo = loadFolder(projectFolder, newProjectInfo, appFolderAndTab, ignoreCustomFolder)

                const tabInfo = loadTab(newProjectInfo, folderInfo.selectFolder, ignoreCustomFolder)

                appFolderAndTabAction.setState({
                    tabRenderList: tabInfo.tabList as AppFolderAndTabStore.appFolderAndTabStoreType['tabRenderList'],
                    tabSelected: tabInfo.selectTab as AppFolderAndTabStore.appFolderAndTabStoreType['tabSelected'],
                    tabIndexSelected: tabInfo.tabIndexSelected,
                    folderList: folderInfo.lstFolder,
                    folderSelected: folderInfo.selectFolder,
                })
            }
        }
    }

    const setTab = (tabIndex: number, newTabSelected: AppFolderAndTabStore.TabSelectedType) => {
        const newTabId = newTabSelected.id === 0
        const isClose = manageProjectStore.projectData?.submitTypeInfo?.value === 17

        if (tabIndex === 0 && isClose && newTabId) {
            const newData = {
                ...newTabSelected,
                id: 21,
            }
            appFolderAndTabAction.setSeletedTab(newData)
        } else {
            appFolderAndTabAction.setSeletedTab(newTabSelected)
        }

        appFolderAndTabAction.setSeletedTabIndex(tabIndex)
        appFolderAndTabAction.resetTabDirty() //clear dirty

        const currentProjectID = manageProjectStore.projectData?.projectID
        const currentSubmittedID = manageProjectStore.projectData?.submittedID
        if (currentProjectID && currentSubmittedID) {
            getProjectByID(currentProjectID, currentSubmittedID).catch((error) => {
                console.error('setTab reload project error:', error)
            })
        }
    }

    const reloadProjectData = async (currentProjectID?: number, currentSubmittedID?: number) => {
        const projectID = currentProjectID ?? manageProjectStore.projectData?.projectID
        const submittedID = currentSubmittedID ?? manageProjectStore.projectData?.submittedID
        if (projectID && submittedID) {
            const reloadResponse = await getFolderAndProject(projectID, submittedID ?? null, true)
            const tabs = loadTab(reloadResponse.projectInfo, appFolderAndTabStore.folderSelected)
            tabs.tabList && appFolderAndTabAction.setTabRenderList(tabs.tabList)
        }
    }

    return {
        isCustomFolder,
        isActionFolder,
        createProjectLoadTabAndFolder,
        loadTabAndFolder,
        setTab,
        getProjectByID,
        reloadProjectData,
    }
}
